import { useState, useEffect, Fragment } from 'react'
import SwiperSlide from "./../../../../commons/components/Slider"
import CategoryTabHeader from './categoryTabHeader'
import CategoryTabContent from './categoryTabContent'
import { useAlbum } from "./../../../../commons/customHooks/Album"
import { useUser } from "./../../../../commons/customHooks/Account"

const CATEGORIES = [
  {label: "카드사진", value: "image_card", contentType: "image"},
  {label: "캐릭터사진", value: "character_selfie", contentType: "image"},
  // {label: "나의 영상편지", value: "video_message", contentType: "video"},
]
const Category = () => {
  const [category, setCategory] = useState(
    CATEGORIES.find(e => e.value == window.localStorage.getItem("home_album_type")) || CATEGORIES[0]
  );

  const [params, setParams] = useState({
    type: window.localStorage.getItem("home_album_type") ?? category.value
  })
  const [albums, loading] = useAlbum(params)

  useEffect(() => {
    setParams({...params, type: category.value})
    window.localStorage.setItem("home_album_type", category.value)
  }, [category])

  useEffect(() => {
    const callFetchAlbumData = () => {
      setParams(p => ({...p}))
    }

    window.callFetchAlbumData = callFetchAlbumData

    return () => {
      window.callFetchAlbumData = undefined
    }
  },[]);

  return (
    <div className="box-category">
      <div className="tabs">
        <div className="tabs__style1">
          <CategoryTabHeader
            active={category}
            categories={CATEGORIES}
            setCategory={setCategory}
          />
          <CategoryTabContent
            active={category}
            categories={CATEGORIES}
            albums={albums}
            loading={loading}
          />
        </div>
      </div>
    </div>
  )
}

export default Category
